import namespace from '../../config/Namespace';

const types = {
  actions: {
    resetList: 'resetList',
    setColumns: 'setColumns',
    setColumnVisibility: 'setColumnVisibility',
    setFilters: 'setFilters',
    fetchPaymentMethods: 'fetchPaymentMethods',
    fetchPaymentMethodsFiltersSuccess: 'fetchPaymentMethodsFiltersSuccess',
    // PaymentMethods Details
    fetchPaymentMethodDetails: 'fetchPaymentMethodDetails',
    fetchPaymentMethodDetailsSuccess: 'fetchPaymentMethodDetailsSuccess',
    fetchPaymentMethodDetailsFailure: 'fetchTransactionDetailsFailure',
  },
};

export default namespace('PaymentMethods', types);
